module.exports = __webpack_public_path__ + "img/behandeling.d844f1ba.jpg";